/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const lt = function(t) {
        const e = [];
        let n = 0;
        for (let r = 0; r < t.length; r++) {
            let i = t.charCodeAt(r);
            i < 128 ? e[n++] = i : i < 2048 ? (e[n++] = i >> 6 | 192, e[n++] = i & 63 | 128) : (i & 64512) === 55296 && r + 1 < t.length && (t.charCodeAt(r + 1) & 64512) === 56320 ? (i = 65536 + ((i & 1023) << 10) + (t.charCodeAt(++r) & 1023), e[n++] = i >> 18 | 240, e[n++] = i >> 12 & 63 | 128, e[n++] = i >> 6 & 63 | 128, e[n++] = i & 63 | 128) : (e[n++] = i >> 12 | 224, e[n++] = i >> 6 & 63 | 128, e[n++] = i & 63 | 128)
        }
        return e
    },
    At = function(t) {
        const e = [];
        let n = 0,
            r = 0;
        for (; n < t.length;) {
            const i = t[n++];
            if (i < 128) e[r++] = String.fromCharCode(i);
            else if (i > 191 && i < 224) {
                const s = t[n++];
                e[r++] = String.fromCharCode((i & 31) << 6 | s & 63)
            } else if (i > 239 && i < 365) {
                const s = t[n++],
                    o = t[n++],
                    a = t[n++],
                    u = ((i & 7) << 18 | (s & 63) << 12 | (o & 63) << 6 | a & 63) - 65536;
                e[r++] = String.fromCharCode(55296 + (u >> 10)), e[r++] = String.fromCharCode(56320 + (u & 1023))
            } else {
                const s = t[n++],
                    o = t[n++];
                e[r++] = String.fromCharCode((i & 15) << 12 | (s & 63) << 6 | o & 63)
            }
        }
        return e.join("")
    },
    ut = {
        byteToCharMap_: null,
        charToByteMap_: null,
        byteToCharMapWebSafe_: null,
        charToByteMapWebSafe_: null,
        ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
        get ENCODED_VALS() {
            return this.ENCODED_VALS_BASE + "+/="
        },
        get ENCODED_VALS_WEBSAFE() {
            return this.ENCODED_VALS_BASE + "-_."
        },
        HAS_NATIVE_SUPPORT: typeof atob == "function",
        encodeByteArray(t, e) {
            if (!Array.isArray(t)) throw Error("encodeByteArray takes an array as a parameter");
            this.init_();
            const n = e ? this.byteToCharMapWebSafe_ : this.byteToCharMap_,
                r = [];
            for (let i = 0; i < t.length; i += 3) {
                const s = t[i],
                    o = i + 1 < t.length,
                    a = o ? t[i + 1] : 0,
                    u = i + 2 < t.length,
                    c = u ? t[i + 2] : 0,
                    h = s >> 2,
                    l = (s & 3) << 4 | a >> 4;
                let m = (a & 15) << 2 | c >> 6,
                    D = c & 63;
                u || (D = 64, o || (m = 64)), r.push(n[h], n[l], n[m], n[D])
            }
            return r.join("")
        },
        encodeString(t, e) {
            return this.HAS_NATIVE_SUPPORT && !e ? btoa(t) : this.encodeByteArray(lt(t), e)
        },
        decodeString(t, e) {
            return this.HAS_NATIVE_SUPPORT && !e ? atob(t) : At(this.decodeStringToByteArray(t, e))
        },
        decodeStringToByteArray(t, e) {
            this.init_();
            const n = e ? this.charToByteMapWebSafe_ : this.charToByteMap_,
                r = [];
            for (let i = 0; i < t.length;) {
                const s = n[t.charAt(i++)],
                    a = i < t.length ? n[t.charAt(i)] : 0;
                ++i;
                const c = i < t.length ? n[t.charAt(i)] : 64;
                ++i;
                const l = i < t.length ? n[t.charAt(i)] : 64;
                if (++i, s == null || a == null || c == null || l == null) throw new St;
                const m = s << 2 | a >> 4;
                if (r.push(m), c !== 64) {
                    const D = a << 4 & 240 | c >> 2;
                    if (r.push(D), l !== 64) {
                        const S = c << 6 & 192 | l;
                        r.push(S)
                    }
                }
            }
            return r
        },
        init_() {
            if (!this.byteToCharMap_) {
                this.byteToCharMap_ = {}, this.charToByteMap_ = {}, this.byteToCharMapWebSafe_ = {}, this.charToByteMapWebSafe_ = {};
                for (let t = 0; t < this.ENCODED_VALS.length; t++) this.byteToCharMap_[t] = this.ENCODED_VALS.charAt(t), this.charToByteMap_[this.byteToCharMap_[t]] = t, this.byteToCharMapWebSafe_[t] = this.ENCODED_VALS_WEBSAFE.charAt(t), this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[t]] = t, t >= this.ENCODED_VALS_BASE.length && (this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(t)] = t, this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(t)] = t)
            }
        }
    };
class St extends Error {
    constructor() {
        super(...arguments), this.name = "DecodeBase64StringError"
    }
}
const Ct = function(t) {
        const e = lt(t);
        return ut.encodeByteArray(e, !0)
    },
    dt = function(t) {
        return Ct(t).replace(/\./g, "")
    },
    Tt = function(t) {
        try {
            return ut.decodeString(t, !0)
        } catch (e) {
            console.error("base64Decode failed: ", e)
        }
        return null
    };
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function $t() {
    if (typeof self < "u") return self;
    if (typeof window < "u") return window;
    if (typeof global < "u") return global;
    throw new Error("Unable to locate global object.")
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Nt = () => $t().__FIREBASE_DEFAULTS__,
    Ot = () => {
        if (typeof process > "u" || typeof process.env > "u") return;
        const t = {}.__FIREBASE_DEFAULTS__;
        if (t) return JSON.parse(t)
    },
    Bt = () => {
        if (typeof document > "u") return;
        let t;
        try {
            t = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/)
        } catch {
            return
        }
        const e = t && Tt(t[1]);
        return e && JSON.parse(e)
    },
    ft = () => {
        try {
            return Nt() || Ot() || Bt()
        } catch (t) {
            console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${t}`);
            return
        }
    },
    xt = t => {
        var e, n;
        return (n = (e = ft()) === null || e === void 0 ? void 0 : e.emulatorHosts) === null || n === void 0 ? void 0 : n[t]
    },
    kt = t => {
        const e = xt(t);
        if (!e) return;
        const n = e.lastIndexOf(":");
        if (n <= 0 || n + 1 === e.length) throw new Error(`Invalid host ${e} with no separate hostname and port!`);
        const r = parseInt(e.substring(n + 1), 10);
        return e[0] === "[" ? [e.substring(1, n - 1), r] : [e.substring(0, n), r]
    },
    ht = () => {
        var t;
        return (t = ft()) === null || t === void 0 ? void 0 : t.config
    };
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Mt {
    constructor() {
        this.reject = () => {}, this.resolve = () => {}, this.promise = new Promise((e, n) => {
            this.resolve = e, this.reject = n
        })
    }
    wrapCallback(e) {
        return (n, r) => {
            n ? this.reject(n) : this.resolve(r), typeof e == "function" && (this.promise.catch(() => {}), e.length === 1 ? e(n) : e(n, r))
        }
    }
}

function Lt() {
    try {
        return typeof indexedDB == "object"
    } catch {
        return !1
    }
}

function Pt() {
    return new Promise((t, e) => {
        try {
            let n = !0;
            const r = "validate-browser-context-for-indexeddb-analytics-module",
                i = self.indexedDB.open(r);
            i.onsuccess = () => {
                i.result.close(), n || self.indexedDB.deleteDatabase(r), t(!0)
            }, i.onupgradeneeded = () => {
                n = !1
            }, i.onerror = () => {
                var s;
                e(((s = i.error) === null || s === void 0 ? void 0 : s.message) || "")
            }
        } catch (n) {
            e(n)
        }
    })
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Rt = "FirebaseError";
class z extends Error {
    constructor(e, n, r) {
        super(n), this.code = e, this.customData = r, this.name = Rt, Object.setPrototypeOf(this, z.prototype), Error.captureStackTrace && Error.captureStackTrace(this, pt.prototype.create)
    }
}
class pt {
    constructor(e, n, r) {
        this.service = e, this.serviceName = n, this.errors = r
    }
    create(e, ...n) {
        const r = n[0] || {},
            i = `${this.service}/${e}`,
            s = this.errors[e],
            o = s ? Ht(s, r) : "Error",
            a = `${this.serviceName}: ${o} (${i}).`;
        return new z(i, a, r)
    }
}

function Ht(t, e) {
    return t.replace(Ft, (n, r) => {
        const i = e[r];
        return i != null ? String(i) : `<${r}?>`
    })
}
const Ft = /\{\$([^}]+)}/g;

function me(t, e) {
    if (t === e) return !0;
    const n = Object.keys(t),
        r = Object.keys(e);
    for (const i of n) {
        if (!r.includes(i)) return !1;
        const s = t[i],
            o = e[i];
        if (Ve(s) && Ve(o)) {
            if (!me(s, o)) return !1
        } else if (s !== o) return !1
    }
    for (const i of r)
        if (!n.includes(i)) return !1;
    return !0
}

function Ve(t) {
    return t !== null && typeof t == "object"
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ne(t) {
    return t && t._delegate ? t._delegate : t
}
class Y {
    constructor(e, n, r) {
        this.name = e, this.instanceFactory = n, this.type = r, this.multipleInstances = !1, this.serviceProps = {}, this.instantiationMode = "LAZY", this.onInstanceCreated = null
    }
    setInstantiationMode(e) {
        return this.instantiationMode = e, this
    }
    setMultipleInstances(e) {
        return this.multipleInstances = e, this
    }
    setServiceProps(e) {
        return this.serviceProps = e, this
    }
    setInstanceCreatedCallback(e) {
        return this.onInstanceCreated = e, this
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const k = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class jt {
    constructor(e, n) {
        this.name = e, this.container = n, this.component = null, this.instances = new Map, this.instancesDeferred = new Map, this.instancesOptions = new Map, this.onInitCallbacks = new Map
    }
    get(e) {
        const n = this.normalizeInstanceIdentifier(e);
        if (!this.instancesDeferred.has(n)) {
            const r = new Mt;
            if (this.instancesDeferred.set(n, r), this.isInitialized(n) || this.shouldAutoInitialize()) try {
                const i = this.getOrInitializeService({
                    instanceIdentifier: n
                });
                i && r.resolve(i)
            } catch {}
        }
        return this.instancesDeferred.get(n).promise
    }
    getImmediate(e) {
        var n;
        const r = this.normalizeInstanceIdentifier(e == null ? void 0 : e.identifier),
            i = (n = e == null ? void 0 : e.optional) !== null && n !== void 0 ? n : !1;
        if (this.isInitialized(r) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: r
            })
        } catch (s) {
            if (i) return null;
            throw s
        } else {
            if (i) return null;
            throw Error(`Service ${this.name} is not available`)
        }
    }
    getComponent() {
        return this.component
    }
    setComponent(e) {
        if (e.name !== this.name) throw Error(`Mismatching Component ${e.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        if (this.component = e, !!this.shouldAutoInitialize()) {
            if (Vt(e)) try {
                this.getOrInitializeService({
                    instanceIdentifier: k
                })
            } catch {}
            for (const [n, r] of this.instancesDeferred.entries()) {
                const i = this.normalizeInstanceIdentifier(n);
                try {
                    const s = this.getOrInitializeService({
                        instanceIdentifier: i
                    });
                    r.resolve(s)
                } catch {}
            }
        }
    }
    clearInstance(e = k) {
        this.instancesDeferred.delete(e), this.instancesOptions.delete(e), this.instances.delete(e)
    }
    async delete() {
        const e = Array.from(this.instances.values());
        await Promise.all([...e.filter(n => "INTERNAL" in n).map(n => n.INTERNAL.delete()), ...e.filter(n => "_delete" in n).map(n => n._delete())])
    }
    isComponentSet() {
        return this.component != null
    }
    isInitialized(e = k) {
        return this.instances.has(e)
    }
    getOptions(e = k) {
        return this.instancesOptions.get(e) || {}
    }
    initialize(e = {}) {
        const {
            options: n = {}
        } = e, r = this.normalizeInstanceIdentifier(e.instanceIdentifier);
        if (this.isInitialized(r)) throw Error(`${this.name}(${r}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const i = this.getOrInitializeService({
            instanceIdentifier: r,
            options: n
        });
        for (const [s, o] of this.instancesDeferred.entries()) {
            const a = this.normalizeInstanceIdentifier(s);
            r === a && o.resolve(i)
        }
        return i
    }
    onInit(e, n) {
        var r;
        const i = this.normalizeInstanceIdentifier(n),
            s = (r = this.onInitCallbacks.get(i)) !== null && r !== void 0 ? r : new Set;
        s.add(e), this.onInitCallbacks.set(i, s);
        const o = this.instances.get(i);
        return o && e(o, i), () => {
            s.delete(e)
        }
    }
    invokeOnInitCallbacks(e, n) {
        const r = this.onInitCallbacks.get(n);
        if (r)
            for (const i of r) try {
                i(e, n)
            } catch {}
    }
    getOrInitializeService({
        instanceIdentifier: e,
        options: n = {}
    }) {
        let r = this.instances.get(e);
        if (!r && this.component && (r = this.component.instanceFactory(this.container, {
                instanceIdentifier: Ut(e),
                options: n
            }), this.instances.set(e, r), this.instancesOptions.set(e, n), this.invokeOnInitCallbacks(r, e), this.component.onInstanceCreated)) try {
            this.component.onInstanceCreated(this.container, e, r)
        } catch {}
        return r || null
    }
    normalizeInstanceIdentifier(e = k) {
        return this.component ? this.component.multipleInstances ? e : k : e
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT"
    }
}

function Ut(t) {
    return t === k ? void 0 : t
}

function Vt(t) {
    return t.instantiationMode === "EAGER"
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class zt {
    constructor(e) {
        this.name = e, this.providers = new Map
    }
    addComponent(e) {
        const n = this.getProvider(e.name);
        if (n.isComponentSet()) throw new Error(`Component ${e.name} has already been registered with ${this.name}`);
        n.setComponent(e)
    }
    addOrOverwriteComponent(e) {
        this.getProvider(e.name).isComponentSet() && this.providers.delete(e.name), this.addComponent(e)
    }
    getProvider(e) {
        if (this.providers.has(e)) return this.providers.get(e);
        const n = new jt(e, this);
        return this.providers.set(e, n), n
    }
    getProviders() {
        return Array.from(this.providers.values())
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var g;
(function(t) {
    t[t.DEBUG = 0] = "DEBUG", t[t.VERBOSE = 1] = "VERBOSE", t[t.INFO = 2] = "INFO", t[t.WARN = 3] = "WARN", t[t.ERROR = 4] = "ERROR", t[t.SILENT = 5] = "SILENT"
})(g || (g = {}));
const Wt = {
        debug: g.DEBUG,
        verbose: g.VERBOSE,
        info: g.INFO,
        warn: g.WARN,
        error: g.ERROR,
        silent: g.SILENT
    },
    Gt = g.INFO,
    qt = {
        [g.DEBUG]: "log",
        [g.VERBOSE]: "log",
        [g.INFO]: "info",
        [g.WARN]: "warn",
        [g.ERROR]: "error"
    },
    Yt = (t, e, ...n) => {
        if (e < t.logLevel) return;
        const r = new Date().toISOString(),
            i = qt[e];
        if (i) console[i](`[${r}]  ${t.name}:`, ...n);
        else throw new Error(`Attempted to log a message with an invalid logType (value: ${e})`)
    };
class Jt {
    constructor(e) {
        this.name = e, this._logLevel = Gt, this._logHandler = Yt, this._userLogHandler = null
    }
    get logLevel() {
        return this._logLevel
    }
    set logLevel(e) {
        if (!(e in g)) throw new TypeError(`Invalid value "${e}" assigned to \`logLevel\``);
        this._logLevel = e
    }
    setLogLevel(e) {
        this._logLevel = typeof e == "string" ? Wt[e] : e
    }
    get logHandler() {
        return this._logHandler
    }
    set logHandler(e) {
        if (typeof e != "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = e
    }
    get userLogHandler() {
        return this._userLogHandler
    }
    set userLogHandler(e) {
        this._userLogHandler = e
    }
    debug(...e) {
        this._userLogHandler && this._userLogHandler(this, g.DEBUG, ...e), this._logHandler(this, g.DEBUG, ...e)
    }
    log(...e) {
        this._userLogHandler && this._userLogHandler(this, g.VERBOSE, ...e), this._logHandler(this, g.VERBOSE, ...e)
    }
    info(...e) {
        this._userLogHandler && this._userLogHandler(this, g.INFO, ...e), this._logHandler(this, g.INFO, ...e)
    }
    warn(...e) {
        this._userLogHandler && this._userLogHandler(this, g.WARN, ...e), this._logHandler(this, g.WARN, ...e)
    }
    error(...e) {
        this._userLogHandler && this._userLogHandler(this, g.ERROR, ...e), this._logHandler(this, g.ERROR, ...e)
    }
}
const Kt = (t, e) => e.some(n => t instanceof n);
let ze, We;

function Xt() {
    return ze || (ze = [IDBDatabase, IDBObjectStore, IDBIndex, IDBCursor, IDBTransaction])
}

function Zt() {
    return We || (We = [IDBCursor.prototype.advance, IDBCursor.prototype.continue, IDBCursor.prototype.continuePrimaryKey])
}
const mt = new WeakMap,
    ge = new WeakMap,
    gt = new WeakMap,
    ue = new WeakMap,
    Oe = new WeakMap;

function Qt(t) {
    const e = new Promise((n, r) => {
        const i = () => {
                t.removeEventListener("success", s), t.removeEventListener("error", o)
            },
            s = () => {
                n($(t.result)), i()
            },
            o = () => {
                r(t.error), i()
            };
        t.addEventListener("success", s), t.addEventListener("error", o)
    });
    return e.then(n => {
        n instanceof IDBCursor && mt.set(n, t)
    }).catch(() => {}), Oe.set(e, t), e
}

function en(t) {
    if (ge.has(t)) return;
    const e = new Promise((n, r) => {
        const i = () => {
                t.removeEventListener("complete", s), t.removeEventListener("error", o), t.removeEventListener("abort", o)
            },
            s = () => {
                n(), i()
            },
            o = () => {
                r(t.error || new DOMException("AbortError", "AbortError")), i()
            };
        t.addEventListener("complete", s), t.addEventListener("error", o), t.addEventListener("abort", o)
    });
    ge.set(t, e)
}
let we = {
    get(t, e, n) {
        if (t instanceof IDBTransaction) {
            if (e === "done") return ge.get(t);
            if (e === "objectStoreNames") return t.objectStoreNames || gt.get(t);
            if (e === "store") return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0])
        }
        return $(t[e])
    },
    set(t, e, n) {
        return t[e] = n, !0
    },
    has(t, e) {
        return t instanceof IDBTransaction && (e === "done" || e === "store") ? !0 : e in t
    }
};

function tn(t) {
    we = t(we)
}

function nn(t) {
    return t === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(e, ...n) {
        const r = t.call(de(this), e, ...n);
        return gt.set(r, e.sort ? e.sort() : [e]), $(r)
    } : Zt().includes(t) ? function(...e) {
        return t.apply(de(this), e), $(mt.get(this))
    } : function(...e) {
        return $(t.apply(de(this), e))
    }
}

function rn(t) {
    return typeof t == "function" ? nn(t) : (t instanceof IDBTransaction && en(t), Kt(t, Xt()) ? new Proxy(t, we) : t)
}

function $(t) {
    if (t instanceof IDBRequest) return Qt(t);
    if (ue.has(t)) return ue.get(t);
    const e = rn(t);
    return e !== t && (ue.set(t, e), Oe.set(e, t)), e
}
const de = t => Oe.get(t);

function sn(t, e, {
    blocked: n,
    upgrade: r,
    blocking: i,
    terminated: s
} = {}) {
    const o = indexedDB.open(t, e),
        a = $(o);
    return r && o.addEventListener("upgradeneeded", u => {
        r($(o.result), u.oldVersion, u.newVersion, $(o.transaction), u)
    }), n && o.addEventListener("blocked", u => n(u.oldVersion, u.newVersion, u)), a.then(u => {
        s && u.addEventListener("close", () => s()), i && u.addEventListener("versionchange", c => i(c.oldVersion, c.newVersion, c))
    }).catch(() => {}), a
}
const on = ["get", "getKey", "getAll", "getAllKeys", "count"],
    an = ["put", "add", "delete", "clear"],
    fe = new Map;

function Ge(t, e) {
    if (!(t instanceof IDBDatabase && !(e in t) && typeof e == "string")) return;
    if (fe.get(e)) return fe.get(e);
    const n = e.replace(/FromIndex$/, ""),
        r = e !== n,
        i = an.includes(n);
    if (!(n in (r ? IDBIndex : IDBObjectStore).prototype) || !(i || on.includes(n))) return;
    const s = async function(o, ...a) {
        const u = this.transaction(o, i ? "readwrite" : "readonly");
        let c = u.store;
        return r && (c = c.index(a.shift())), (await Promise.all([c[n](...a), i && u.done]))[0]
    };
    return fe.set(e, s), s
}
tn(t => ({
    ...t,
    get: (e, n, r) => Ge(e, n) || t.get(e, n, r),
    has: (e, n) => !!Ge(e, n) || t.has(e, n)
}));
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class cn {
    constructor(e) {
        this.container = e
    }
    getPlatformInfoString() {
        return this.container.getProviders().map(n => {
            if (ln(n)) {
                const r = n.getImmediate();
                return `${r.library}/${r.version}`
            } else return null
        }).filter(n => n).join(" ")
    }
}

function ln(t) {
    const e = t.getComponent();
    return (e == null ? void 0 : e.type) === "VERSION"
}
const be = "@firebase/app",
    qe = "0.9.10";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const M = new Jt("@firebase/app"),
    un = "@firebase/app-compat",
    dn = "@firebase/analytics-compat",
    fn = "@firebase/analytics",
    hn = "@firebase/app-check-compat",
    pn = "@firebase/app-check",
    mn = "@firebase/auth",
    gn = "@firebase/auth-compat",
    wn = "@firebase/database",
    bn = "@firebase/database-compat",
    _n = "@firebase/functions",
    yn = "@firebase/functions-compat",
    En = "@firebase/installations",
    vn = "@firebase/installations-compat",
    In = "@firebase/messaging",
    Dn = "@firebase/messaging-compat",
    An = "@firebase/performance",
    Sn = "@firebase/performance-compat",
    Cn = "@firebase/remote-config",
    Tn = "@firebase/remote-config-compat",
    $n = "@firebase/storage",
    Nn = "@firebase/storage-compat",
    On = "@firebase/firestore",
    Bn = "@firebase/firestore-compat",
    xn = "firebase";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const _e = "[DEFAULT]",
    kn = {
        [be]: "fire-core",
        [un]: "fire-core-compat",
        [fn]: "fire-analytics",
        [dn]: "fire-analytics-compat",
        [pn]: "fire-app-check",
        [hn]: "fire-app-check-compat",
        [mn]: "fire-auth",
        [gn]: "fire-auth-compat",
        [wn]: "fire-rtdb",
        [bn]: "fire-rtdb-compat",
        [_n]: "fire-fn",
        [yn]: "fire-fn-compat",
        [En]: "fire-iid",
        [vn]: "fire-iid-compat",
        [In]: "fire-fcm",
        [Dn]: "fire-fcm-compat",
        [An]: "fire-perf",
        [Sn]: "fire-perf-compat",
        [Cn]: "fire-rc",
        [Tn]: "fire-rc-compat",
        [$n]: "fire-gcs",
        [Nn]: "fire-gcs-compat",
        [On]: "fire-fst",
        [Bn]: "fire-fst-compat",
        "fire-js": "fire-js",
        [xn]: "fire-js-all"
    };
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ne = new Map,
    ye = new Map;

function Mn(t, e) {
    try {
        t.container.addComponent(e)
    } catch (n) {
        M.debug(`Component ${e.name} failed to register with FirebaseApp ${t.name}`, n)
    }
}

function re(t) {
    const e = t.name;
    if (ye.has(e)) return M.debug(`There were multiple attempts to register component ${e}.`), !1;
    ye.set(e, t);
    for (const n of ne.values()) Mn(n, t);
    return !0
}

function Ln(t, e) {
    const n = t.container.getProvider("heartbeat").getImmediate({
        optional: !0
    });
    return n && n.triggerHeartbeat(), t.container.getProvider(e)
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Pn = {
        ["no-app"]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
        ["bad-app-name"]: "Illegal App name: '{$appName}",
        ["duplicate-app"]: "Firebase App named '{$appName}' already exists with different options or config",
        ["app-deleted"]: "Firebase App named '{$appName}' already deleted",
        ["no-options"]: "Need to provide options, when not being deployed to hosting via source.",
        ["invalid-app-argument"]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
        ["invalid-log-argument"]: "First argument to `onLog` must be null or a function.",
        ["idb-open"]: "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
        ["idb-get"]: "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
        ["idb-set"]: "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
        ["idb-delete"]: "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}."
    },
    N = new pt("app", "Firebase", Pn);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Rn {
    constructor(e, n, r) {
        this._isDeleted = !1, this._options = Object.assign({}, e), this._config = Object.assign({}, n), this._name = n.name, this._automaticDataCollectionEnabled = n.automaticDataCollectionEnabled, this._container = r, this.container.addComponent(new Y("app", () => this, "PUBLIC"))
    }
    get automaticDataCollectionEnabled() {
        return this.checkDestroyed(), this._automaticDataCollectionEnabled
    }
    set automaticDataCollectionEnabled(e) {
        this.checkDestroyed(), this._automaticDataCollectionEnabled = e
    }
    get name() {
        return this.checkDestroyed(), this._name
    }
    get options() {
        return this.checkDestroyed(), this._options
    }
    get config() {
        return this.checkDestroyed(), this._config
    }
    get container() {
        return this._container
    }
    get isDeleted() {
        return this._isDeleted
    }
    set isDeleted(e) {
        this._isDeleted = e
    }
    checkDestroyed() {
        if (this.isDeleted) throw N.create("app-deleted", {
            appName: this._name
        })
    }
}

function wt(t, e = {}) {
    let n = t;
    typeof e != "object" && (e = {
        name: e
    });
    const r = Object.assign({
            name: _e,
            automaticDataCollectionEnabled: !1
        }, e),
        i = r.name;
    if (typeof i != "string" || !i) throw N.create("bad-app-name", {
        appName: String(i)
    });
    if (n || (n = ht()), !n) throw N.create("no-options");
    const s = ne.get(i);
    if (s) {
        if (me(n, s.options) && me(r, s.config)) return s;
        throw N.create("duplicate-app", {
            appName: i
        })
    }
    const o = new zt(i);
    for (const u of ye.values()) o.addComponent(u);
    const a = new Rn(n, r, o);
    return ne.set(i, a), a
}

function Hn(t = _e) {
    const e = ne.get(t);
    if (!e && t === _e && ht()) return wt();
    if (!e) throw N.create("no-app", {
        appName: t
    });
    return e
}

function j(t, e, n) {
    var r;
    let i = (r = kn[t]) !== null && r !== void 0 ? r : t;
    n && (i += `-${n}`);
    const s = i.match(/\s|\//),
        o = e.match(/\s|\//);
    if (s || o) {
        const a = [`Unable to register library "${i}" with version "${e}":`];
        s && a.push(`library name "${i}" contains illegal characters (whitespace or "/")`), s && o && a.push("and"), o && a.push(`version name "${e}" contains illegal characters (whitespace or "/")`), M.warn(a.join(" "));
        return
    }
    re(new Y(`${i}-version`, () => ({
        library: i,
        version: e
    }), "VERSION"))
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Fn = "firebase-heartbeat-database",
    jn = 1,
    J = "firebase-heartbeat-store";
let he = null;

function bt() {
    return he || (he = sn(Fn, jn, {
        upgrade: (t, e) => {
            switch (e) {
                case 0:
                    t.createObjectStore(J)
            }
        }
    }).catch(t => {
        throw N.create("idb-open", {
            originalErrorMessage: t.message
        })
    })), he
}
async function Un(t) {
    try {
        return await (await bt()).transaction(J).objectStore(J).get(_t(t))
    } catch (e) {
        if (e instanceof z) M.warn(e.message);
        else {
            const n = N.create("idb-get", {
                originalErrorMessage: e == null ? void 0 : e.message
            });
            M.warn(n.message)
        }
    }
}
async function Ye(t, e) {
    try {
        const r = (await bt()).transaction(J, "readwrite");
        await r.objectStore(J).put(e, _t(t)), await r.done
    } catch (n) {
        if (n instanceof z) M.warn(n.message);
        else {
            const r = N.create("idb-set", {
                originalErrorMessage: n == null ? void 0 : n.message
            });
            M.warn(r.message)
        }
    }
}

function _t(t) {
    return `${t.name}!${t.options.appId}`
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Vn = 1024,
    zn = 30 * 24 * 60 * 60 * 1e3;
class Wn {
    constructor(e) {
        this.container = e, this._heartbeatsCache = null;
        const n = this.container.getProvider("app").getImmediate();
        this._storage = new qn(n), this._heartbeatsCachePromise = this._storage.read().then(r => (this._heartbeatsCache = r, r))
    }
    async triggerHeartbeat() {
        const n = this.container.getProvider("platform-logger").getImmediate().getPlatformInfoString(),
            r = Je();
        if (this._heartbeatsCache === null && (this._heartbeatsCache = await this._heartbeatsCachePromise), !(this._heartbeatsCache.lastSentHeartbeatDate === r || this._heartbeatsCache.heartbeats.some(i => i.date === r))) return this._heartbeatsCache.heartbeats.push({
            date: r,
            agent: n
        }), this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter(i => {
            const s = new Date(i.date).valueOf();
            return Date.now() - s <= zn
        }), this._storage.overwrite(this._heartbeatsCache)
    }
    async getHeartbeatsHeader() {
        if (this._heartbeatsCache === null && await this._heartbeatsCachePromise, this._heartbeatsCache === null || this._heartbeatsCache.heartbeats.length === 0) return "";
        const e = Je(),
            {
                heartbeatsToSend: n,
                unsentEntries: r
            } = Gn(this._heartbeatsCache.heartbeats),
            i = dt(JSON.stringify({
                version: 2,
                heartbeats: n
            }));
        return this._heartbeatsCache.lastSentHeartbeatDate = e, r.length > 0 ? (this._heartbeatsCache.heartbeats = r, await this._storage.overwrite(this._heartbeatsCache)) : (this._heartbeatsCache.heartbeats = [], this._storage.overwrite(this._heartbeatsCache)), i
    }
}

function Je() {
    return new Date().toISOString().substring(0, 10)
}

function Gn(t, e = Vn) {
    const n = [];
    let r = t.slice();
    for (const i of t) {
        const s = n.find(o => o.agent === i.agent);
        if (s) {
            if (s.dates.push(i.date), Ke(n) > e) {
                s.dates.pop();
                break
            }
        } else if (n.push({
                agent: i.agent,
                dates: [i.date]
            }), Ke(n) > e) {
            n.pop();
            break
        }
        r = r.slice(1)
    }
    return {
        heartbeatsToSend: n,
        unsentEntries: r
    }
}
class qn {
    constructor(e) {
        this.app = e, this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck()
    }
    async runIndexedDBEnvironmentCheck() {
        return Lt() ? Pt().then(() => !0).catch(() => !1) : !1
    }
    async read() {
        return await this._canUseIndexedDBPromise ? await Un(this.app) || {
            heartbeats: []
        } : {
            heartbeats: []
        }
    }
    async overwrite(e) {
        var n;
        if (await this._canUseIndexedDBPromise) {
            const i = await this.read();
            return Ye(this.app, {
                lastSentHeartbeatDate: (n = e.lastSentHeartbeatDate) !== null && n !== void 0 ? n : i.lastSentHeartbeatDate,
                heartbeats: e.heartbeats
            })
        } else return
    }
    async add(e) {
        var n;
        if (await this._canUseIndexedDBPromise) {
            const i = await this.read();
            return Ye(this.app, {
                lastSentHeartbeatDate: (n = e.lastSentHeartbeatDate) !== null && n !== void 0 ? n : i.lastSentHeartbeatDate,
                heartbeats: [...i.heartbeats, ...e.heartbeats]
            })
        } else return
    }
}

function Ke(t) {
    return dt(JSON.stringify({
        version: 2,
        heartbeats: t
    })).length
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Yn(t) {
    re(new Y("platform-logger", e => new cn(e), "PRIVATE")), re(new Y("heartbeat", e => new Wn(e), "PRIVATE")), j(be, qe, t), j(be, qe, "esm2017"), j("fire-js", "")
}
Yn("");
var Jn = "firebase",
    Kn = "9.22.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
j(Jn, Kn, "app");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Xn = "type.googleapis.com/google.protobuf.Int64Value",
    Zn = "type.googleapis.com/google.protobuf.UInt64Value";

function yt(t, e) {
    const n = {};
    for (const r in t) t.hasOwnProperty(r) && (n[r] = e(t[r]));
    return n
}

function Ee(t) {
    if (t == null) return null;
    if (t instanceof Number && (t = t.valueOf()), typeof t == "number" && isFinite(t) || t === !0 || t === !1 || Object.prototype.toString.call(t) === "[object String]") return t;
    if (t instanceof Date) return t.toISOString();
    if (Array.isArray(t)) return t.map(e => Ee(e));
    if (typeof t == "function" || typeof t == "object") return yt(t, e => Ee(e));
    throw new Error("Data cannot be encoded in JSON: " + t)
}

function ie(t) {
    if (t == null) return t;
    if (t["@type"]) switch (t["@type"]) {
        case Xn:
        case Zn: {
            const e = Number(t.value);
            if (isNaN(e)) throw new Error("Data cannot be decoded from JSON: " + t);
            return e
        }
        default:
            throw new Error("Data cannot be decoded from JSON: " + t)
    }
    return Array.isArray(t) ? t.map(e => ie(e)) : typeof t == "function" || typeof t == "object" ? yt(t, e => ie(e)) : t
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Be = "functions";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Xe = {
    OK: "ok",
    CANCELLED: "cancelled",
    UNKNOWN: "unknown",
    INVALID_ARGUMENT: "invalid-argument",
    DEADLINE_EXCEEDED: "deadline-exceeded",
    NOT_FOUND: "not-found",
    ALREADY_EXISTS: "already-exists",
    PERMISSION_DENIED: "permission-denied",
    UNAUTHENTICATED: "unauthenticated",
    RESOURCE_EXHAUSTED: "resource-exhausted",
    FAILED_PRECONDITION: "failed-precondition",
    ABORTED: "aborted",
    OUT_OF_RANGE: "out-of-range",
    UNIMPLEMENTED: "unimplemented",
    INTERNAL: "internal",
    UNAVAILABLE: "unavailable",
    DATA_LOSS: "data-loss"
};
class U extends z {
    constructor(e, n, r) {
        super(`${Be}/${e}`, n || ""), this.details = r
    }
}

function Qn(t) {
    if (t >= 200 && t < 300) return "ok";
    switch (t) {
        case 0:
            return "internal";
        case 400:
            return "invalid-argument";
        case 401:
            return "unauthenticated";
        case 403:
            return "permission-denied";
        case 404:
            return "not-found";
        case 409:
            return "aborted";
        case 429:
            return "resource-exhausted";
        case 499:
            return "cancelled";
        case 500:
            return "internal";
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline-exceeded"
    }
    return "unknown"
}

function er(t, e) {
    let n = Qn(t),
        r = n,
        i;
    try {
        const s = e && e.error;
        if (s) {
            const o = s.status;
            if (typeof o == "string") {
                if (!Xe[o]) return new U("internal", "internal");
                n = Xe[o], r = o
            }
            const a = s.message;
            typeof a == "string" && (r = a), i = s.details, i !== void 0 && (i = ie(i))
        }
    } catch {}
    return n === "ok" ? null : new U(n, r, i)
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class tr {
    constructor(e, n, r) {
        this.auth = null, this.messaging = null, this.appCheck = null, this.auth = e.getImmediate({
            optional: !0
        }), this.messaging = n.getImmediate({
            optional: !0
        }), this.auth || e.get().then(i => this.auth = i, () => {}), this.messaging || n.get().then(i => this.messaging = i, () => {}), this.appCheck || r.get().then(i => this.appCheck = i, () => {})
    }
    async getAuthToken() {
        if (this.auth) try {
            const e = await this.auth.getToken();
            return e == null ? void 0 : e.accessToken
        } catch {
            return
        }
    }
    async getMessagingToken() {
        if (!(!this.messaging || !("Notification" in self) || Notification.permission !== "granted")) try {
            return await this.messaging.getToken()
        } catch {
            return
        }
    }
    async getAppCheckToken() {
        if (this.appCheck) {
            const e = await this.appCheck.getToken();
            return e.error ? null : e.token
        }
        return null
    }
    async getContext() {
        const e = await this.getAuthToken(),
            n = await this.getMessagingToken(),
            r = await this.getAppCheckToken();
        return {
            authToken: e,
            messagingToken: n,
            appCheckToken: r
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ve = "us-central1";

function nr(t) {
    let e = null;
    return {
        promise: new Promise((n, r) => {
            e = setTimeout(() => {
                r(new U("deadline-exceeded", "deadline-exceeded"))
            }, t)
        }),
        cancel: () => {
            e && clearTimeout(e)
        }
    }
}
class rr {
    constructor(e, n, r, i, s = ve, o) {
        this.app = e, this.fetchImpl = o, this.emulatorOrigin = null, this.contextProvider = new tr(n, r, i), this.cancelAllRequests = new Promise(a => {
            this.deleteService = () => Promise.resolve(a())
        });
        try {
            const a = new URL(s);
            this.customDomain = a.origin, this.region = ve
        } catch {
            this.customDomain = null, this.region = s
        }
    }
    _delete() {
        return this.deleteService()
    }
    _url(e) {
        const n = this.app.options.projectId;
        return this.emulatorOrigin !== null ? `${this.emulatorOrigin}/${n}/${this.region}/${e}` : this.customDomain !== null ? `${this.customDomain}/${e}` : `https://${this.region}-${n}.cloudfunctions.net/${e}`
    }
}

function ir(t, e, n) {
    t.emulatorOrigin = `http://${e}:${n}`
}

function sr(t, e, n) {
    return r => ar(t, e, r, n || {})
}
async function or(t, e, n, r) {
    n["Content-Type"] = "application/json";
    let i;
    try {
        i = await r(t, {
            method: "POST",
            body: JSON.stringify(e),
            headers: n
        })
    } catch {
        return {
            status: 0,
            json: null
        }
    }
    let s = null;
    try {
        s = await i.json()
    } catch {}
    return {
        status: i.status,
        json: s
    }
}

function ar(t, e, n, r) {
    const i = t._url(e);
    return cr(t, i, n, r)
}
async function cr(t, e, n, r) {
    n = Ee(n);
    const i = {
            data: n
        },
        s = {},
        o = await t.contextProvider.getContext();
    o.authToken && (s.Authorization = "Bearer " + o.authToken), o.messagingToken && (s["Firebase-Instance-ID-Token"] = o.messagingToken), o.appCheckToken !== null && (s["X-Firebase-AppCheck"] = o.appCheckToken);
    const a = r.timeout || 7e4,
        u = nr(a),
        c = await Promise.race([or(e, i, s, t.fetchImpl), u.promise, t.cancelAllRequests]);
    if (u.cancel(), !c) throw new U("cancelled", "Firebase Functions instance was deleted.");
    const h = er(c.status, c.json);
    if (h) throw h;
    if (!c.json) throw new U("internal", "Response is not valid JSON object.");
    let l = c.json.data;
    if (typeof l > "u" && (l = c.json.result), typeof l > "u") throw new U("internal", "Response is missing data field.");
    return {
        data: ie(l)
    }
}
const Ze = "@firebase/functions",
    Qe = "0.9.4";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const lr = "auth-internal",
    ur = "app-check-internal",
    dr = "messaging-internal";

function fr(t, e) {
    const n = (r, {
        instanceIdentifier: i
    }) => {
        const s = r.getProvider("app").getImmediate(),
            o = r.getProvider(lr),
            a = r.getProvider(dr),
            u = r.getProvider(ur);
        return new rr(s, o, a, u, i, t)
    };
    re(new Y(Be, n, "PUBLIC").setMultipleInstances(!0)), j(Ze, Qe, e), j(Ze, Qe, "esm2017")
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function hr(t = Hn(), e = ve) {
    const r = Ln(Ne(t), Be).getImmediate({
            identifier: e
        }),
        i = kt("functions");
    return i && pr(r, ...i), r
}

function pr(t, e, n) {
    ir(Ne(t), e, n)
}

function mr(t, e, n) {
    return sr(Ne(t), e, n)
}
fr(fetch.bind(self));
const gr = {
        apiKey: "AIzaSyB97EznpGQOivYuon6pmg5KB9BAA5koEqA",
        authDomain: "mozaico-dalle2.firebaseapp.com",
        projectId: "mozaico-dalle2",
        storageBucket: "mozaico-dalle2.appspot.com",
        messagingSenderId: "65498491172",
        appId: "1:65498491172:web:f621ba48335c04a34cabb1"
    },
    wr = wt(gr),
    br = hr(wr),
    _r = mr(br, "generateImageFromText");

function C() {}

function Et(t) {
    return t()
}

function et() {
    return Object.create(null)
}

function K(t) {
    t.forEach(Et)
}

function vt(t) {
    return typeof t == "function"
}

function xe(t, e) {
    return t != t ? e == e : t !== e || t && typeof t == "object" || typeof t == "function"
}
let ee;

function se(t, e) {
    return ee || (ee = document.createElement("a")), ee.href = e, t === ee.href
}

function yr(t) {
    return Object.keys(t).length === 0
}
const Er = typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : global;
"WeakMap" in Er;

function p(t, e) {
    t.appendChild(e)
}

function I(t, e, n) {
    t.insertBefore(e, n || null)
}

function E(t) {
    t.parentNode && t.parentNode.removeChild(t)
}

function vr(t, e) {
    for (let n = 0; n < t.length; n += 1) t[n] && t[n].d(e)
}

function w(t) {
    return document.createElement(t)
}

function X(t) {
    return document.createTextNode(t)
}

function A() {
    return X(" ")
}

function Ir() {
    return X("")
}

function oe(t, e, n, r) {
    return t.addEventListener(e, n, r), () => t.removeEventListener(e, n, r)
}

function Dr(t) {
    return function(e) {
        return e.preventDefault(), t.call(this, e)
    }
}

function f(t, e, n) {
    n == null ? t.removeAttribute(e) : t.getAttribute(e) !== n && t.setAttribute(e, n)
}

function Ar(t) {
    return Array.from(t.childNodes)
}

function tt(t, e) {
    t.value = e ?? ""
}

function Sr(t, e, n, r) {
    n == null ? t.style.removeProperty(e) : t.style.setProperty(e, n, r ? "important" : "")
}
let ke;

function q(t) {
    ke = t
}
const F = [],
    Ie = [];
let V = [];
const De = [],
    Cr = Promise.resolve();
let Ae = !1;

function Tr() {
    Ae || (Ae = !0, Cr.then(It))
}

function Se(t) {
    V.push(t)
}

function $r(t) {
    De.push(t)
}
const pe = new Set;
let H = 0;

function It() {
    if (H !== 0) return;
    const t = ke;
    do {
        try {
            for (; H < F.length;) {
                const e = F[H];
                H++, q(e), Nr(e.$$)
            }
        } catch (e) {
            throw F.length = 0, H = 0, e
        }
        for (q(null), F.length = 0, H = 0; Ie.length;) Ie.pop()();
        for (let e = 0; e < V.length; e += 1) {
            const n = V[e];
            pe.has(n) || (pe.add(n), n())
        }
        V.length = 0
    } while (F.length);
    for (; De.length;) De.pop()();
    Ae = !1, pe.clear(), q(t)
}

function Nr(t) {
    if (t.fragment !== null) {
        t.update(), K(t.before_update);
        const e = t.dirty;
        t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, e), t.after_update.forEach(Se)
    }
}

function Or(t) {
    const e = [],
        n = [];
    V.forEach(r => t.indexOf(r) === -1 ? e.push(r) : n.push(r)), n.forEach(r => r()), V = e
}
const te = new Set;
let Br;

function Ce(t, e) {
    t && t.i && (te.delete(t), t.i(e))
}

function nt(t, e, n, r) {
    if (t && t.o) {
        if (te.has(t)) return;
        te.add(t), Br.c.push(() => {
            te.delete(t), r && (n && t.d(1), r())
        }), t.o(e)
    } else r && r()
}
const xr = ["allowfullscreen", "allowpaymentrequest", "async", "autofocus", "autoplay", "checked", "controls", "default", "defer", "disabled", "formnovalidate", "hidden", "inert", "ismap", "loop", "multiple", "muted", "nomodule", "novalidate", "open", "playsinline", "readonly", "required", "reversed", "selected"];
[...xr];

function kr(t, e, n) {
    const r = t.$$.props[e];
    r !== void 0 && (t.$$.bound[r] = n, n(t.$$.ctx[r]))
}

function rt(t) {
    t && t.c()
}

function Te(t, e, n, r) {
    const {
        fragment: i,
        after_update: s
    } = t.$$;
    i && i.m(e, n), r || Se(() => {
        const o = t.$$.on_mount.map(Et).filter(vt);
        t.$$.on_destroy ? t.$$.on_destroy.push(...o) : K(o), t.$$.on_mount = []
    }), s.forEach(Se)
}

function $e(t, e) {
    const n = t.$$;
    n.fragment !== null && (Or(n.after_update), K(n.on_destroy), n.fragment && n.fragment.d(e), n.on_destroy = n.fragment = null, n.ctx = [])
}

function Mr(t, e) {
    t.$$.dirty[0] === -1 && (F.push(t), Tr(), t.$$.dirty.fill(0)), t.$$.dirty[e / 31 | 0] |= 1 << e % 31
}

function Me(t, e, n, r, i, s, o, a = [-1]) {
    const u = ke;
    q(t);
    const c = t.$$ = {
        fragment: null,
        ctx: [],
        props: s,
        update: C,
        not_equal: i,
        bound: et(),
        on_mount: [],
        on_destroy: [],
        on_disconnect: [],
        before_update: [],
        after_update: [],
        context: new Map(e.context || (u ? u.$$.context : [])),
        callbacks: et(),
        dirty: a,
        skip_bound: !1,
        root: e.target || u.$$.root
    };
    o && o(c.root);
    let h = !1;
    if (c.ctx = n ? n(t, e.props || {}, (l, m, ...D) => {
            const S = D.length ? D[0] : m;
            return c.ctx && i(c.ctx[l], c.ctx[l] = S) && (!c.skip_bound && c.bound[l] && c.bound[l](S), h && Mr(t, l)), m
        }) : [], c.update(), h = !0, K(c.before_update), c.fragment = r ? r(c.ctx) : !1, e.target) {
        if (e.hydrate) {
            const l = Ar(e.target);
            c.fragment && c.fragment.l(l), l.forEach(E)
        } else c.fragment && c.fragment.c();
        e.intro && Ce(t.$$.fragment), Te(t, e.target, e.anchor, e.customElement), It()
    }
    q(u)
}
class Le {
    $destroy() {
        $e(this, 1), this.$destroy = C
    }
    $on(e, n) {
        if (!vt(n)) return C;
        const r = this.$$.callbacks[e] || (this.$$.callbacks[e] = []);
        return r.push(n), () => {
            const i = r.indexOf(n);
            i !== -1 && r.splice(i, 1)
        }
    }
    $set(e) {
        this.$$set && !yr(e) && (this.$$.skip_bound = !0, this.$$set(e), this.$$.skip_bound = !1)
    }
}

function Lr(t) {
    let e, n, r;
    return {
        c() {
            e = w("button"), e.innerHTML = '<p class="tw-text-3xl tw-m-0 !tw-text-orange-600">★</p>', f(e, "class", "tw-m-0 tw-p-0 hover:tw-outline-2 tw-border-none tw-font-semibold tw-h-[4rem] tw-w-[4rem] tw-rounded-full active:tw-bg-orange-100 tw-bg-orange-50 tw-flex tw-items-center tw-justify-center"), f(e, "type", "button")
        },
        m(i, s) {
            I(i, e, s), n || (r = oe(e, "click", t[0]), n = !0)
        },
        p: C,
        i: C,
        o: C,
        d(i) {
            i && E(e), n = !1, r()
        }
    }
}

function Pr(t, e, n) {
    let {
        value: r = null
    } = e, i = ["A mosaic tile art piece depicting an abstract interpretation of the four seasons, with each season represented by a different color palette", "A large-scale mosaic mural of an oceanic scene, using a variety of blue tiles to depict the depth and diversity of sea life", "A circular mosaic tile art piece inspired by Vincent van Gogh's Starry Night, made with vibrant and textured tiles", "A mosaic portrait of a tiger in the wild, using a variety of orange, black, and white tiles to capture the intricate details of its fur", "A mosaic tile representation of a city skyline at sunset, with buildings rendered in shades of grey tiles and the sky in a gradient of orange and red tiles"];
    const s = () => Math.floor(Math.random() * i.length),
        o = () => n(1, r = i[s()]);
    return t.$$set = a => {
        "value" in a && n(1, r = a.value)
    }, [o, r]
}
class Rr extends Le {
    constructor(e) {
        super(), Me(this, e, Pr, Lr, xe, {
            value: 1
        })
    }
}

function it(t) {
    let e;
    return {
        c() {
            e = w("div"), e.innerHTML = `<div class="tw-text-center tw-bg-white tw-p-8 tw-rounded-lg"><div class="tw-rounded-full tw-m-auto tw-h-14 tw-w-14 tw-border-solid tw-animate-spin tw-border-2 tw-orange-blue-500 tw-border-r-transparent"></div> 

            <p class="tw-text-2xl tw-font-semibold tw-mt-4">The design is being generated, please wait...</p></div>`, f(e, "class", "tw-bg-white-500 tw-flex tw-items-center tw-justify-center tw-absolute tw-h-full tw-w-full tw-top-0 tw-left-0")
        },
        m(n, r) {
            I(n, e, r)
        },
        d(n) {
            n && E(e)
        }
    }
}

function Hr(t) {
    let e;
    return {
        c() {
            e = w("div"), e.innerHTML = `<svg class="tw-fill-gray-500 tw-m-auto tw-mb-4" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48"><path d="M200-160q-22.25 0-38.817-16.567-16.568-16.567-16.568-38.817v-529.232q0-22.25 16.568-38.817Q177.75-800 200-800h358.231v30.769H200q-10.769 0-17.692 6.923t-6.923 17.692v529.232q0 10.769 6.923 17.692T200-190.769h529.231q10.769 0 17.692-6.923t6.923-17.692v-357.231h30.77v357.231q0 22.25-16.568 38.817Q751.481-160 729.231-160H200Zm504.615-478.769v-81h-80.23v-30.77h80.23v-80.23h30.77v80.23h80.231v30.77h-80.231v81h-30.77Zm-420 337.538H650.77L540.616-447.846l-107.77 135.461-71.692-86.308-76.539 97.462Zm-109.23-468v578.462-578.462Z"></path></svg> 

          <p class="tw-px-8 tw-text-center tw-text-2xl tw-text-gray-500 tw-max-h-16">Generate Your Own Mosaic Design With AI.</p>`, f(e, "class", "tw-flex tw-flex-col tw-justify-center")
        },
        m(n, r) {
            I(n, e, r)
        },
        p: C,
        d(n) {
            n && E(e)
        }
    }
}

function Fr(t) {
    let e, n;
    return {
        c() {
            e = w("img"), f(e, "alt", "selected art design"), f(e, "class", "tw-object-cover tw-w-full tw-h-full"), se(e.src, n = t[1]) || f(e, "src", n)
        },
        m(r, i) {
            I(r, e, i)
        },
        p(r, i) {
            i & 2 && !se(e.src, n = r[1]) && f(e, "src", n)
        },
        d(r) {
            r && E(e)
        }
    }
}

function jr(t) {
    let e, n, r, i, s, o, a = t[0] && it();

    function u(l, m) {
        if (l[1]) return Fr;
        if (!l[0]) return Hr
    }
    let c = u(t),
        h = c && c(t);
    return {
        c() {
            e = w("div"), n = w("div"), r = w("div"), i = A(), s = w("div"), a && a.c(), o = A(), h && h.c(), f(r, "alt", "selected art design"), f(r, "class", "tw-object-cover tw-w-full tw-h-full tw-absolute tw-top-0 tw-left-0"), Sr(s, "box-shadow", "rgba(0, 0, 0, 0.2) 0px 4px 6px -1px, rgba(0, 0, 0, 0.2) 0px 0px 4px -1px"), f(s, "class", "tw-bg-white tw-bg-opacity-10 tw-backdrop-blur-sm tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center tw-relative"), f(n, "class", "tw-h-full tw-relative tw-rounded-sm tw-border tw-flex tw-items-center tw-justify-center"), f(e, "class", "md:tw-h-[56rem] tw-h-[48rem] border tw-m-auto tw-border-2 tw-border-solid tw-border-gray-200 tw-bg-white tw-rounded-2xl tw-overflow-hidden")
        },
        m(l, m) {
            I(l, e, m), p(e, n), p(n, r), p(n, i), p(n, s), a && a.m(s, null), p(s, o), h && h.m(s, null)
        },
        p(l, [m]) {
            l[0] ? a || (a = it(), a.c(), a.m(s, o)) : a && (a.d(1), a = null), c === (c = u(l)) && h ? h.p(l, m) : (h && h.d(1), h = c && c(l), h && (h.c(), h.m(s, null)))
        },
        i: C,
        o: C,
        d(l) {
            l && E(e), a && a.d(), h && h.d()
        }
    }
}

function Ur(t, e, n) {
    let {
        isLoading: r = !0
    } = e, {
        selectedImage: i = null
    } = e;
    return t.$$set = s => {
        "isLoading" in s && n(0, r = s.isLoading), "selectedImage" in s && n(1, i = s.selectedImage)
    }, [r, i]
}
class Vr extends Le {
    constructor(e) {
        super(), Me(this, e, Ur, jr, xe, {
            isLoading: 0,
            selectedImage: 1
        })
    }
}
const zr = t => {
    t ? document.querySelector('.aaa_formbuilder_container').style.display = "block" : document.querySelector('.aaa_formbuilder_container').style.display = "none";
    let e = setInterval(() => {
        if (document.querySelector(".dalle-image-url")) {
            clearInterval(e);
            let n = document.querySelector(".dalle-image-url");
            n.value = t + "?"
        }
    }, 1e3)
};

function st(t, e, n) {
    const r = t.slice();
    return r[8] = e[n].src, r[3] = e[n].prompt, r[10] = n, r
}

function Wr(t) {
    let e;
    return {
        c() {
            e = X("Generate Your Design")
        },
        m(n, r) {
            I(n, e, r)
        },
        d(n) {
            n && E(e)
        }
    }
}

function Gr(t) {
    let e;
    return {
        c() {
            e = X("Generating...")
        },
        m(n, r) {
            I(n, e, r)
        },
        d(n) {
            n && E(e)
        }
    }
}

function ot(t) {
    let e, n, r, i, s, o, a, u;

    function c() {
        return t[7](t[10])
    }
    return {
        c() {
            e = w("button"), n = w("img"), s = A(), f(n, "class", "tw-w-full tw-h-full cursor-pointer tw-rounded-md"), f(n, "alt", r = t[3] + "-" + t[10]), se(n.src, i = t[8]) || f(n, "src", i), e.disabled = t[2], f(e, "class", o = "tw-cursor-pointer tw-p-0 tw-h-32 tw-w-32 tw-min-w-[8rem] tw-min-h-[8rem] tw-object-cover tw-border-none tw-bg-transparent " + (t[1].indexOf(t[0]) === t[10] ? "tw-opacity-50" : ""))
        },
        m(h, l) {
            I(h, e, l), p(e, n), p(e, s), a || (u = oe(e, "click", c), a = !0)
        },
        p(h, l) {
            t = h, l & 2 && r !== (r = t[3] + "-" + t[10]) && f(n, "alt", r), l & 2 && !se(n.src, i = t[8]) && f(n, "src", i), l & 4 && (e.disabled = t[2]), l & 3 && o !== (o = "tw-cursor-pointer tw-p-0 tw-h-32 tw-w-32 tw-min-w-[8rem] tw-min-h-[8rem] tw-object-cover tw-border-none tw-bg-transparent " + (t[1].indexOf(t[0]) === t[10] ? "tw-opacity-50" : "")) && f(e, "class", o)
        },
        d(h) {
            h && E(e), a = !1, u()
        }
    }
}

function at(t) {
    let e, n, r;
    return {
        c() {
            e = w("div"), n = w("a"), r = X("Inquire About This Design"), f(n, "href", "#aaa-form-builder"), f(n, "disabled", t[2]), f(n, "class", "button button--primary"), f(e, "class", "tw-text-right tw-pb-14 md:tw-pr-64")
        },
        m(i, s) {
            I(i, e, s), p(e, n), p(n, r)
        },
        p(i, s) {
            s & 4 && f(n, "disabled", i[2])
        },
        d(i) {
            i && E(e)
        }
    }
}

function qr(t) {
    let e, n, r, i, s, o, a, u, c, h, l, m, D, S, O, Pe, L, W, Re, Z, B, ae, G, P, ce, He;

    function Dt(d) {
        t[5](d)
    }
    let Fe = {};
    t[3] !== void 0 && (Fe.value = t[3]), c = new Rr({
        props: Fe
    }), Ie.push(() => kr(c, "value", Dt));

    function je(d, _) {
        return d[2] ? Gr : Wr
    }
    let Q = je(t),
        T = Q(t),
        R = t[1],
        b = [];
    for (let d = 0; d < R.length; d += 1) b[d] = ot(st(t, R, d));
    B = new Vr({
        props: {
            isLoading: t[2],
            selectedImage: t[0]
        }
    });
    let y = t[0] && at(t);
    return {
        c() {
            e = w("div"), n = w("form"), r = w("div"), r.innerHTML = `<h1 class="tw-text-5xl tw-mt-0 tw-mb-4 tw-font-bold tw-leading-snug">Generate Your Own Mosaic Design With AI</h1> 
      <p class="tw-mt-0 tw-leading-snug tw-text-2xl tw-text-gray-500">With AI, The possibilities are endless! Create your own mosaic design
        that is limited only by your imagination.</p>`, i = A(), s = w("hr"), o = A(), a = w("div"), u = w("div"), rt(c.$$.fragment), l = A(), m = w("textarea"), D = A(), S = w("div"), O = w("button"), T.c(), Pe = A(), L = w("div"), W = w("div");
            for (let d = 0; d < b.length; d += 1) b[d].c();
            Re = A(), Z = w("div"), rt(B.$$.fragment), ae = A(), y && y.c(), G = Ir(), f(s, "class", "tw-my-0 tw-mb-8 tw-opacity-0"), f(u, "class", "text-right tw-absolute tw-bottom-12 tw-right-4"), m.required = !0, f(m, "row", "8"), m.disabled = t[2], f(m, "placeholder", "Enter your idea here or use the ★ botton use some of the examples from us."), f(m, "class", "tw-resize-none tw-leading-snug tw-w-full tw-h-48 tw-outline-none focus:tw-shadow-none tw-border-2 focus:tw-border-gray-500 tw-p-6"), f(a, "class", "flex-1 tw-relative"), O.disabled = t[2], f(O, "class", "button button--full-width button--primary"), f(S, "class", "tw-mt-4"), f(n, "class", "tw-flex tw-flex-col tw-h-full tw-flex-[0_0_40%]"), f(W, "class", "art-history-container tw-max-w-[600px] tw-mb-8 tw-justify-center tw-items-center tw-border-gray-300 tw-overflow-scroll md:tw-min-w-[80px] !tw-flex tw-flex-row tw-gap-4"), f(Z, "class", "tw-relative tw-w-full"), f(L, "class", "tw-flex tw-gap-y-4 tw-flex-col-reverse tw-gap-4 tw-w-full"), f(e, "class", "tw-flex md:tw-flex-row tw-flex-col-reverse tw-items-center tw-gap-32 tw-py-24 tw-pb-8")
        },
        m(d, _) {
            I(d, e, _), p(e, n), p(n, r), p(n, i), p(n, s), p(n, o), p(n, a), p(a, u), Te(c, u, null), p(a, l), p(a, m), tt(m, t[3]), p(n, D), p(n, S), p(S, O), T.m(O, null), p(e, Pe), p(e, L), p(L, W);
            for (let x = 0; x < b.length; x += 1) b[x] && b[x].m(W, null);
            p(L, Re), p(L, Z), Te(B, Z, null), I(d, ae, _), y && y.m(d, _), I(d, G, _), P = !0, ce || (He = [oe(m, "input", t[6]), oe(n, "submit", Dr(t[4]))], ce = !0)
        },
        p(d, [_]) {
            const x = {};
            if (!h && _ & 8 && (h = !0, x.value = d[3], $r(() => h = !1)), c.$set(x), (!P || _ & 4) && (m.disabled = d[2]), _ & 8 && tt(m, d[3]), Q !== (Q = je(d)) && (T.d(1), T = Q(d), T && (T.c(), T.m(O, null))), (!P || _ & 4) && (O.disabled = d[2]), _ & 7) {
                R = d[1];
                let v;
                for (v = 0; v < R.length; v += 1) {
                    const Ue = st(d, R, v);
                    b[v] ? b[v].p(Ue, _) : (b[v] = ot(Ue), b[v].c(), b[v].m(W, null))
                }
                for (; v < b.length; v += 1) b[v].d(1);
                b.length = R.length
            }
            const le = {};
            _ & 4 && (le.isLoading = d[2]), _ & 1 && (le.selectedImage = d[0]), B.$set(le), d[0] ? y ? y.p(d, _) : (y = at(d), y.c(), y.m(G.parentNode, G)) : y && (y.d(1), y = null)
        },
        i(d) {
            P || (Ce(c.$$.fragment, d), Ce(B.$$.fragment, d), P = !0)
        },
        o(d) {
            nt(c.$$.fragment, d), nt(B.$$.fragment, d), P = !1
        },
        d(d) {
            d && E(e), $e(c), T.d(), vr(b, d), $e(B), d && E(ae), y && y.d(d), d && E(G), ce = !1, K(He)
        }
    }
}

function Yr(t, e, n) {
    let r = "",
        i = [],
        s = !1,
        o = "";
    const a = () => (n(2, s = !0), _r({
        prompt: r,
        uid: Date.now().toString()
    }).then(({
        data: l
    }) => (n(2, s = !1), n(0, o = l[0].src), n(1, i = l))).catch(l => (n(2, s = !1), console.error(l), alert("Something went wrong while generating the images. Please try again later."))));

    function u(l) {
        r = l, n(3, r)
    }

    function c() {
        r = this.value, n(3, r)
    }
    const h = l => n(0, o = i[l].src);
    return t.$$.update = () => {
        t.$$.dirty & 1 && o && zr(o)
    }, [o, i, s, r, a, u, c, h]
}
class Jr extends Le {
    constructor(e) {
        super(), Me(this, e, Yr, qr, xe, {})
    }
}
const ct = document.getElementById("artGenerator");
ct && new Jr({
    target: ct
});
	


